import { render, staticRenderFns } from "./DeviceDetailDialog.vue?vue&type=template&id=2a5257c4&scoped=true&"
import script from "./DeviceDetailDialog.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetailDialog.vue?vue&type=style&index=0&id=2a5257c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5257c4",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/DashboardDeviceTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Fcbs%2Fdashboard%2FDeviceDetailDialog.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports